/**
 * GENERATED — do not edit by hand.
 * Regenerate with: python3 scripts/extract_cgm_geometry.py <path-to-kml>
 *
 * Sanitized CGM geography, geometry only. The source KML carries LoRaWAN root
 * credentials in its placemark description fields; none of that content reaches
 * this file. There are no device ids, no relay bindings and no commissioning
 * state here — only placemark names and coordinates.
 *
 * Names are the VERBATIM KML strings. Resolving them to canonical Agri Safe
 * parcels/sectors happens in `cgmGeography.ts`, so `cgm_pilot_topology.json`
 * stays the single operational authority.
 *
 * Coordinates are Leaflet order: [lat, lng].
 */

export interface CgmPolygonGeometry {
  /** Verbatim KML placemark name. Not a canonical parcel name. */
  readonly kmlName: string;
  /** Outer ring, [lat, lng]. Single ring — the source has no holes. */
  readonly ring: ReadonlyArray<readonly [number, number]>;
}

export interface CgmPointGeometry {
  readonly kmlName: string;
  readonly position: readonly [number, number];
}

/** Parcel polygons present in the CGM survey. All lie within the Roubia site. */
export const CGM_PARCEL_POLYGONS: ReadonlyArray<CgmPolygonGeometry> = [
  {
    kmlName: "Marselan Puy",
    ring: [
      [43.24193595947346, 2.813650758132284],
      [43.2415995905711, 2.813860379521371],
      [43.24151222146925, 2.813921592247119],
      [43.24147859756144, 2.813944123513432],
      [43.24142657186168, 2.813969155974576],
      [43.24126328584175, 2.814086911244471],
      [43.24118668702526, 2.814202888097153],
      [43.24111410474715, 2.81430919757965],
      [43.24105790688152, 2.814458464032867],
      [43.24099909098521, 2.814598892234834],
      [43.24095175060302, 2.814657748553633],
      [43.24089993139394, 2.814734694327405],
      [43.24087300120083, 2.814784765110245],
      [43.24169755846495, 2.815702857311568],
      [43.24177549721934, 2.815560497171692],
      [43.24179690221937, 2.81550341157808],
      [43.24182879941879, 2.815411287085805],
      [43.24186408723632, 2.815348521714844],
      [43.2419108072077, 2.81526378679938],
      [43.24199001404896, 2.815162515147116],
      [43.24205251295285, 2.815123817658522],
      [43.24213176547728, 2.815036346938216],
      [43.24220554744215, 2.814975115278953],
      [43.24226942128102, 2.814900146593213],
      [43.24231292645726, 2.814858663597555],
      [43.24215391050293, 2.814229631245788],
      [43.24207178071858, 2.813905894605973],
      [43.24202808365061, 2.813746144469054],
      [43.24193595947346, 2.813650758132284],
    ],
  },
  {
    kmlName: "Caladoc Plantade",
    ring: [
      [43.24160418611807, 2.812440076915166],
      [43.24146582747791, 2.812211125438089],
      [43.239990338734, 2.812625220465657],
      [43.24010590102702, 2.812860488223872],
      [43.23935807011401, 2.81334577765713],
      [43.23956689453031, 2.813876834700351],
      [43.24160418611807, 2.812440076915166],
    ],
  },
  {
    kmlName: "Chardonnay Pigassou",
    ring: [
      [43.23958157254028, 2.813898539939876],
      [43.23971678966069, 2.81421276342277],
      [43.24040823917883, 2.813709914931464],
      [43.2404887036099, 2.813790961755915],
      [43.24056585578965, 2.813870279555784],
      [43.24072299389245, 2.813974160110002],
      [43.24082874104432, 2.814027795869376],
      [43.24095644929237, 2.81408368577386],
      [43.24101953567619, 2.814136868280519],
      [43.24110911372814, 2.814149799915882],
      [43.24126512484412, 2.814025207617343],
      [43.24139840662417, 2.813904107079166],
      [43.24162624826821, 2.813775134851728],
      [43.24175633454325, 2.8136771239422],
      [43.24189942967038, 2.813551296424914],
      [43.2419882120878, 2.813445506875594],
      [43.24220724963984, 2.812952234263237],
      [43.2420654504007, 2.812882989782328],
      [43.24189369757893, 2.812789169163414],
      [43.24171195295126, 2.812690011444139],
      [43.24157885733768, 2.812478989128298],
      [43.23958157254028, 2.813898539939876],
    ],
  },
  {
    kmlName: "Marlot Puy Jeune",
    ring: [
      [43.24139916229652, 2.812178928898434],
      [43.24127793601656, 2.811959736993348],
      [43.24112611274584, 2.811744457943501],
      [43.24101782585522, 2.811586696237083],
      [43.24094074838258, 2.811369428519226],
      [43.24084576045723, 2.811150708160961],
      [43.24070919074283, 2.811223419615259],
      [43.2405627433494, 2.811288457480352],
      [43.24043909395344, 2.811387213820578],
      [43.24036781889779, 2.811439726658715],
      [43.24029680388487, 2.811470755421495],
      [43.2402394865335, 2.811503219239428],
      [43.24019436181179, 2.811503225833374],
      [43.24015056245081, 2.811475802130465],
      [43.2401036234119, 2.811500356999583],
      [43.24006044173431, 2.81152026415129],
      [43.23981110010404, 2.811673709853355],
      [43.23969120663003, 2.811753619913604],
      [43.23957196795574, 2.811825609638645],
      [43.23949781199045, 2.811870648421109],
      [43.23997081018495, 2.812599561319669],
      [43.24139916229652, 2.812178928898434],
    ],
  },
  {
    kmlName: "Merlot Puy vieux",
    ring: [
      [43.24080974957617, 2.810960252384651],
      [43.2407371893162, 2.810760744168783],
      [43.24064272161353, 2.810407448217389],
      [43.24056132372303, 2.810052545921438],
      [43.24050629662368, 2.809742356202567],
      [43.24046589698558, 2.809561595907195],
      [43.2404308581977, 2.809413077955518],
      [43.23949806700894, 2.80987509133827],
      [43.23965926515959, 2.810564015937338],
      [43.23972447778164, 2.810645438289079],
      [43.23977698930484, 2.810711575109139],
      [43.23988214635621, 2.810860921019618],
      [43.23999799992676, 2.810991240220808],
      [43.24008465606145, 2.811111479975881],
      [43.24013009107949, 2.811188444698016],
      [43.24014662719186, 2.811293002429189],
      [43.24014755004006, 2.811338994091648],
      [43.24080974957617, 2.810960252384651],
    ],
  },
  {
    kmlName: "Marselan Barthés",
    ring: [
      [43.23901377784767, 2.812656014749499],
      [43.23938045070705, 2.813319261655836],
      [43.24010381583812, 2.812865223193628],
      [43.23998139608236, 2.812626288185369],
      [43.23996554559449, 2.812626293730813],
      [43.2397686223557, 2.812329601891956],
      [43.23959928918251, 2.81237967833269],
      [43.23938996064676, 2.812482935314715],
      [43.23924343571612, 2.812545900057755],
      [43.23915031716913, 2.812568271853091],
      [43.23901377784767, 2.812656014749499],
    ],
  },
  {
    kmlName: "Cabernet Gortti",
    ring: [
      [43.24013153347052, 2.811421705813],
      [43.240102595312, 2.811215426942235],
      [43.24004318956261, 2.811092202964394],
      [43.23995930993908, 2.810976332536201],
      [43.23976829970047, 2.810770434503538],
      [43.239476454506, 2.810849528718875],
      [43.23916975360213, 2.810887096145425],
      [43.2388368723349, 2.810922106644065],
      [43.23856675170865, 2.810935938247727],
      [43.2382853574974, 2.810951343293866],
      [43.2381618194115, 2.810950158459096],
      [43.23801760066384, 2.810951178556103],
      [43.23816068601544, 2.812894335862663],
      [43.23914698651464, 2.81251022625832],
      [43.23963362783466, 2.812339777451291],
      [43.23962973899546, 2.812141032928213],
      [43.23950269452199, 2.811916787300126],
      [43.2394992280495, 2.811798509904528],
      [43.24013153347052, 2.811421705813],
    ],
  },
  {
    kmlName: "Caladoc Grotti",
    ring: [
      [43.23816454732098, 2.813029245107039],
      [43.23808971781354, 2.812020972470617],
      [43.23806743354328, 2.81178216898557],
      [43.23804372017411, 2.811658265488728],
      [43.23803001707035, 2.811584968489138],
      [43.23801413539242, 2.811508462885026],
      [43.23798725559251, 2.811381995367268],
      [43.23799011672327, 2.811257412834778],
      [43.23792936175877, 2.811126534716875],
      [43.23791304873009, 2.811088352453743],
      [43.23778953937197, 2.811092515948372],
      [43.23766789011785, 2.811107307935707],
      [43.2378214664828, 2.813234310242052],
      [43.2382785689659, 2.81449255265765],
      [43.2386954662248, 2.81429435643036],
      [43.23886035934681, 2.814761079482027],
      [43.23958976609046, 2.81425445042504],
      [43.23899451611568, 2.812723766992116],
      [43.23857181046747, 2.812877652311923],
      [43.23816454732098, 2.813029245107039],
    ],
  },
];

/**
 * Pumping-location coordinates whose KML name explicitly names a CGM site.
 * GEOGRAPHY ONLY — these never define a relay/device binding. Lezignan has no
 * surveyed pumping coordinate and is intentionally absent.
 */
export const CGM_PUMP_POINTS: ReadonlyArray<CgmPointGeometry> = [
  { kmlName: "Pompage Roubia", position: [43.23874160509984, 2.815374025096411] },
  { kmlName: "Pompage Moulin Luc", position: [43.1815475, 2.7803242] },
  { kmlName: "Pompage surpression BRL Escales", position: [43.220749, 2.7499043] },
];
